import type { ReactNode } from "react";

import { SectionHeader } from "#/components/SectionHeader";

import { TERMS_SECTIONS, type TermsBlock } from "./-terms.sections";

export const TERMS_LAST_UPDATED = "2026-06-04";

export function TermsDocument() {
  return (
    <div className="max-w-3xl space-y-10 text-[15px] leading-7 text-foreground">
      {TERMS_SECTIONS.map((section) => (
        <TermsSection key={section.title} title={section.title} blocks={section.blocks} />
      ))}
    </div>
  );
}

function TermsSection({ title, blocks }: { title: string; blocks: TermsBlock[] }) {
  return (
    <section className="flex flex-col gap-4 border-b border-border pb-10 last:border-b-0 last:pb-0">
      <SectionHeader>{title}</SectionHeader>
      {blocks.map((block, index) => (
        <TermsBlockContent key={index} block={block} />
      ))}
    </section>
  );
}

function TermsBlockContent({ block }: { block: TermsBlock }) {
  return (
    <>
      {block.paragraphs?.map((paragraph, index) => (
        <TermsParagraph key={index}>{paragraph}</TermsParagraph>
      ))}
      {block.list ? <TermsList items={block.list} /> : null}
    </>
  );
}

function TermsParagraph({ children }: { children: ReactNode }) {
  return <p className="text-[15px] leading-7 text-muted-foreground">{children}</p>;
}

function TermsList({ items }: { items: readonly ReactNode[] }) {
  return (
    <ul className="list-disc space-y-2 pl-5 text-[15px] leading-7 text-muted-foreground">
      {items.map((item, index) => (
        <li key={index} className="pl-1">
          {item}
        </li>
      ))}
    </ul>
  );
}
